import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import zh from './zh/zh.json';
import en from './en/en.json';

const resources = {
    zh: {
        translation: zh,
    },
    en: {
        translation: en,
    },
};

/*international language*/
let intl_lang = 'zh';

// let browser_lang = navigator.language;
// browser_lang = browser_lang.substr(0, 2);
// if (browser_lang && 'zh' === browser_lang) {
//     intl_lang = 'zh';
// }

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: intl_lang,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;



// WEBPACK FOOTER //
// ./src/libs/i18n/i18n.js